
import Main from './components/main';
function App() {
  return (
<>
 <Main></Main>
</>
  );
}

export default App;
